import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const NaviHealthPage = lazy(() => import("./NaviHealthPage"));

const NaviHealthPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <NaviHealthPage />
    </Suspense>
  );
};

export default NaviHealthPageLazy;
